import { render, staticRenderFns } from "./mainDrawing.vue?vue&type=template&id=24a0b176&scoped=true"
import script from "./mainDrawing.vue?vue&type=script&lang=js"
export * from "./mainDrawing.vue?vue&type=script&lang=js"
import style0 from "./mainDrawing.vue?vue&type=style&index=0&id=24a0b176&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0b176",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a0b176')) {
      api.createRecord('24a0b176', component.options)
    } else {
      api.reload('24a0b176', component.options)
    }
    module.hot.accept("./mainDrawing.vue?vue&type=template&id=24a0b176&scoped=true", function () {
      api.rerender('24a0b176', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/mainDrawing.vue"
export default component.exports